module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"title":"Pildykite užklausos formą ir mūsų ekspertai su jumis susisieks per 1 d.d.!","email":"El. Paštas","name":"Vardas arba įmonės pavadinimas","phone":"Telefono numeris","message":"Žinutė","send":"Pateikti užklausą","success":"Dėkojame! Netrukus su jumis susisieksime."}}')
  delete Component.options._Ctor
}
